export function findFocusableElements(containerEl = document) {
    const focusableSelectors = [
        "a[href]",
        "area[href]",
        "input:not([disabled])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        "[tabindex]",
    ];

    const focusableElements = [
        ...containerEl.querySelectorAll(focusableSelectors.join(",")),
    ].filter((el) => {
        return (
            el.offsetParent !== null && // Not hidden via display: none
            !el.hasAttribute("disabled") &&
            !el.getAttribute("aria-hidden")
        ); // Ensures it's tabbable
    });

    return focusableElements;
}

window.__focusTraps = []

export function focusTrap(element) {
    if (!element) {
        console.error("Element missing...");
    }

    let isPausedListening = false
    let isInitialized = false
    let triggerEl = null
    let focusableElements = [];

    const init = () => {
        if (isInitialized) {
            return
        }

        triggerEl = document.activeElement
        
        update()
        
        focusFirst()

        document.addEventListener("focus", handleDocumentFocus, true);

        window.__focusTraps.forEach(x => {
            if (x === instance) {
                return
            }
            x.pauseListening()
        })

        isInitialized = true
    }
    
    const update = () => {
        focusableElements = findFocusableElements(element)
        if (!focusableElements) {
            element.setAttribute("tabindex", "-1");
            focusableElements.push(element);
        }
    }

    const focusFirst = () => {
        focusableElements[0].focus();
    };

    // const focusLast = () => {
    //     focusableElements[focusableElements.length - 1].focus();
    // };

    const handleDocumentFocus = (event) => {
        if (element.contains(event.target) || isPausedListening) {
            return
        }

        focusFirst()
    };

    const destroy = () => {
        document.removeEventListener("focus", handleDocumentFocus, true);

        if (triggerEl) {
            triggerEl.focus()
        }

        const index = window.__focusTraps.findIndex(x => x === instance)
        __focusTraps.splice(index,1)

        const firstAvailableFocusTrap = window.__focusTraps[window.__focusTraps.length - 1]
        if (firstAvailableFocusTrap) {
            firstAvailableFocusTrap.resumeListening()
        }
    }
    
    const pauseListening = () => {
        isPausedListening = true
    }

    const resumeListening = () => {
        isPausedListening = true
    }

    const instance = {
        init,
        destroy,
        focusFirst,
        update,
        pauseListening,
        resumeListening
    };

    window.__focusTraps.push(instance)

    return instance
}

export function runFocusSkip() {
    let prevFocusEl = document.activeElement

    const goToNextVisibleFocusElement = () => {
        const focusableEls = findFocusableElements(document.body)
        let currentIndex = focusableEls.findIndex(el => document.activeElement === el)
        if (currentIndex < 0) {
            console.error('focused element not found')
            return
        }

        let prevIndex = focusableEls.findIndex(el => prevFocusEl === el)

        if (prevIndex > currentIndex) {
            focusableEls.reverse()
            currentIndex = focusableEls.length - currentIndex - 1
        }

        const el = focusableEls.find((element,index) => {
            if (index > currentIndex) {
                const toggleEl = element.closest('[data-component="ToggleBlock"]')
                if (!toggleEl) {
                    return true
                }
                if (toggleEl.classList.contains('is-open')) {
                    return true
                }
            }
            return false
        })

        if (!el) {
            console.error('next focus el not found')
            return
        }

        el.focus()
        prevFocusEl = el
    }

    const handleDocumentFocus = (event) => {
        if (!(event.target instanceof HTMLElement)) {
            return
        }
        const toggleEl = event.target.closest('[data-component="ToggleBlock"]:not([data-ignorefocusskip])')
        if (toggleEl && !toggleEl.classList.contains('is-open')) {
            goToNextVisibleFocusElement()
            return
        }

        prevFocusEl = event.target
    }

    document.addEventListener('focus', handleDocumentFocus, true)
}